import React from "react";
import ReactDOM from "react-dom";
import { Switch, Route, BrowserRouter, Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "./assets/css/shards.min.css";
import "./assets/css/uicons-regular-rounded.css";
import "./assets/css/style.css";
import "./assets/scss/style.scss";

import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import NotFound from "./pages/NotFound";
import { getToken } from "./services/authService";
import ForgotPassword from "./pages/ForgotPassword";
import ForgotPasswordSubmit from "./pages/ForgotPasswordSubmit";
import { Provider } from "react-redux";
import store from "./store/Store";

toast.configure();

const RouteApp = () => {
  const token = getToken();

  return (
    <BrowserRouter>
      <Switch>
        <Route
          exact
          path="/"
          render={(props) => {
            if (token) return <Redirect to="/dashboard/overview" />;
            return <Auth {...props} />;
          }}
        />

        <Route
          path="/dashboard"
          render={(props) => {
            if (!token) return <Redirect to="/" />;
            return <Dashboard {...props} />;
          }}
        />

        <Route
          path="/forgot-password"
          render={(props) => {
            if (token) return <Redirect to="/dashboard/overview" />;
            return <ForgotPassword {...props} />;
          }}
        />

        <Route
          path="/forgot-password-submit/:email"
          component={ForgotPasswordSubmit}
        />

        <Route path="/notfound" component={NotFound} />
        <Redirect from="*" to="/notfound" />
      </Switch>
    </BrowserRouter>
  );
};

// ✅ Final single render wrapped with Redux Provider
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouteApp />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
